module.exports = __webpack_public_path__ + "static/img/1549a4f97f4e7687c46a2e8f1bed5e2.8690a76b.jpg";